<template>
  <section class="home-hero">
    <Carousel v-if="banners.length" autoplay :autoplay-speed="5000" loop arrow="never" :radius-dot="true">
      <CarouselItem v-for="(item, index) in banners" :key="item.id">
        <a v-if="item.link" :href="item.link" target="_blank" rel="noopener">
          <img
            :src="resolveAssetUrl(item.image)"
            :alt="item.alt || item.title"
            class="hero-img"
            :loading="index === 0 ? 'eager' : 'lazy'"
            :fetchpriority="index === 0 ? 'high' : 'auto'"
          >
        </a>
        <img
          v-else
          :src="resolveAssetUrl(item.image)"
          :alt="item.alt || item.title"
          class="hero-img"
          :loading="index === 0 ? 'eager' : 'lazy'"
          :fetchpriority="index === 0 ? 'high' : 'auto'"
        >
      </CarouselItem>
    </Carousel>
    <img v-else :src="displayHero.image" :alt="displayHero.alt" class="hero-img" loading="eager" fetchpriority="high">
  </section>
</template>

<script>
import { resolveAssetUrl } from '@/utils/api'

export default {
  name: 'HomeCarousel',
  props: {
    hero: {
      type: Object,
      default: () => ({
        image: '/uploads/banner/home-hero.jpg',
        alt: '源盛国际 专注新西兰签证移民',
      }),
    },
    banners: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    displayHero() {
      return {
        image: resolveAssetUrl(this.hero?.image || '/uploads/banner/home-hero.jpg'),
        alt: this.hero?.alt || '源盛国际 专注新西兰签证移民',
      }
    },
  },
  methods: {
    resolveAssetUrl,
  },
}
</script>

<style scoped>
.home-hero {
  position: relative;
  height: clamp(260px, 25.5vw, 490px);
  background: #fff;
  overflow: hidden;
}

.home-hero a,
.home-hero /deep/ .ivu-carousel,
.home-hero /deep/ .ivu-carousel-list,
.home-hero /deep/ .ivu-carousel-track,
.home-hero /deep/ .ivu-carousel-item {
  height: 100%;
}

.home-hero /deep/ .ivu-carousel-list {
  overflow: hidden;
}

.hero-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.home-hero /deep/ .ivu-carousel-dots li {
  margin: 0 5px;
}

.home-hero /deep/ .ivu-carousel-dots li button.radius {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  opacity: 1;
  transition: transform 0.25s ease, background-color 0.25s ease, box-shadow 0.25s ease;
}

.home-hero /deep/ .ivu-carousel-dots li.ivu-carousel-active > button.radius {
  width: 13px;
  height: 13px;
  background: #ffffff;
  border-color: rgba(255, 255, 255, 0.98);
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2), 0 3px 10px rgba(0, 0, 0, 0.14);
  transform: scale(1.02);
}

.home-hero /deep/ .ivu-carousel-dots-inside {
  bottom: 22px;
}
</style>
